// removed by extract-text-webpack-plugin
module.exports = {"filters":"_-src-components-FilterList-styles---filters---2-7pZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FilterList/styles.css
// module id = 774
// module chunks = 0